import type { FaireProductEntity } from "../../entity_types/product";

export const p_pjtt45u2hd: FaireProductEntity = {
  token: "p_pjtt45u2hd",
  type: "product",
  name: "Discovery Collection Kit",
  brandToken: "b_bwpw9saddb",
  brandName: "Somerset Moss (No Duties | Ships from CA | USMCA Compliant)",
  imageUrl:
    "https://cdn.faire.com/fastly/eb528f9d5614ba87a67fb9dade06f07fcde81205a84238bd22e4ff2a78919444.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cf9817e97fe5181deca59b5d292e523007712ce32eb764d293a69a9791990588.jpeg",
    "https://cdn.faire.com/fastly/a9f157656c471fc519bc429432499a59278467e4bac1e9ff8cf7d3364ed81f71.jpeg",
  ],
  priceDollars: 67.5,
  description:
    "The Discovery Collection  - Everything you need to achieve skin confidence.\n\nPerfect for gifting or travel - Infuse your skin with ultimate nourishment and anti-ageing benefits. These products work synergistically to hydrate, rejuvenate, and restore youthful vitality. All while saving the environment, your wallet and witnessing results within a matter of days.\n\nIncludes:\n\nFacial Mist 50ml + Facial Oil 30ml+ Balm 25ml+ Brightening Mask 25ml all in a cute Somerset Moss drawstring bag.\n\nFacial Mist - 50 ml \n\nA supercharged Serum that is also a Mist! Achieve beautiful dewy skin effortlessly.\n\nFacial Oil - 30ml \n\nSimplify your routine with its dual role as both a cleanser and moisturizer.\n\nBalm - 25ml \n\nStrengthens and regenerates your skin's natural barrier. Even the most sensitive skin finds its calm.\n\nMask - 25ml\n\nExfoliates and hydrates, making dullness a thing of the past.\n\n",
  tags: [],
  msrpDollars: 135,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:43.044Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
